module.exports = __webpack_public_path__ + "static/media/spring.449e8efb.svg";